import { getCompatConfig } from '../compat.js';

const getCompatEnv = () => {
  return getCompatConfig().ENVIRONMENT;
};

export { getCompatEnv };
//# sourceMappingURL=environment.js.map
